import { isEcoBeamDesign } from './ecoBeamPricing';

const NON_QUOTABLE_UNIQUE_IDS = new Set(['awaiting-sku', 'no-skyciv-engineering']);

export const isAssignedSku = (uniqueId) => {
    if (uniqueId == null || uniqueId === '') return false;
    return !NON_QUOTABLE_UNIQUE_IDS.has(uniqueId);
};

export const isQuotableDesign = (design) => {
    if (!design) return false;
    if (!isAssignedSku(design.unique_id)) return false;
    if (isEcoBeamDesign(design)) return false;
    return true;
};
